module.exports = __webpack_public_path__ + "static/media/leaf-wrong.9de4ad95.svg";